import { CodeHighlight } from '@mantine/code-highlight';
import { useHover } from '@mantine/hooks';
import clsx from 'clsx';
import type { SelectedOperation } from '~/server/logic/prisma/operation-select';
import OperationControl from '../OperationControl';

/** For code block operations */
export default function CodeBlockInner({
  readonly,
  onClick,
  code,
  selected,
  disableMenu,
  operation,
  previewCursorAllowed,
  testContentId,
  stepOrder,
  editing,
}: {
  onClick?: () => void;
  code: string;
  selected?: boolean;
  readonly?: boolean;
  disableMenu?: boolean;
  operation?: SelectedOperation;
  previewCursorAllowed: boolean;
  testContentId: string;
  stepOrder: number;
  editing?: boolean;
}) {
  const { ref: hoveredRef } = useHover();

  return (
    <div
      ref={hoveredRef}
      className="group relative ml-1 w-full pr-8"
    >
      <div
        onClick={onClick}
        className={clsx(`w-full rounded-[7px] border border-zinc-300 hover:cursor-pointer dark:border-zinc-700`, {
          'outline outline-2 outline-teal-600': selected,
        })}
      >
        <CodeHighlight
          className="w-full rounded-lg"
          classNames={{
            // Required to break the code to fit into the container
            code: 'rounded-lg break-all whitespace-pre-wrap',
            codeHighlight: 'rounded-lg',
            scrollarea: 'rounded-lg',
          }}
          expandCodeLabel="↓"
          code={code}
          language="tsx"
          withCopyButton={false}
          // We don't want to collapse short code snippets
          expanded={code.length < 250}
        />
      </div>
      {!disableMenu && !!operation && (
        <div
          className={clsx(
            'absolute right-0 top-1/2 -translate-y-1/2 opacity-0 transition-opacity delay-200 group-hover:opacity-100',
            readonly || editing ? 'invisible' : '',
          )}
        >
          <OperationControl
            operation={operation}
            previewCursorAllowed={previewCursorAllowed}
            testContentId={testContentId}
            stepOrder={stepOrder}
          />
        </div>
      )}
    </div>
  );
}
